import React, { createContext, useContext } from 'react';

// Checkout does not require Stripe.js in the browser. Retain this provider as
// a no-op compatibility boundary for the application shell.
const StripeContext = createContext({});

export const StripeProvider = ({ children }) => (
  <StripeContext.Provider value={{}}>
    {children}
  </StripeContext.Provider>
);

export const useStripeContext = () => useContext(StripeContext);

export default StripeContext;